import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e0767c40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "identity" }
const _hoisted_2 = { class: "user-info" }
const _hoisted_3 = { class: "user-avatar f-avatar" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "user-identity" }
const _hoisted_6 = { class: "user-name" }
const _hoisted_7 = { class: "user-uid" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"normal","margin-right":"10px"} }, "UID:", -1))
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "qrcode-info" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("關閉")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.currentUser.avatar
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.currentUser.name), 1),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createTextVNode(_toDisplayString(_ctx.currentUser.uid), 1)
        ])
      ])
    ]),
    (_ctx.qrcode)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "qrcode",
          src: _ctx.qrcode,
          alt: "QR Code"
        }, null, 8, _hoisted_9))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.remainSeconds > 0 ? _ctx.remainSeconds : 0) + "秒後失效 ", 1),
    _createVNode(_component_a_button, {
      class: "close-btn",
      onClick: _ctx.close
    }, {
      default: _withCtx(() => [
        _hoisted_11
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}